const NField = require('./nfield');

module.exports = class NText extends NField {

};
